var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextVv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E6F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.75C10.8914 6.75 6.75 10.8914 6.75 16C6.75 21.1086 10.8914 25.25 16 25.25C21.1086 25.25 25.25 21.1086 25.25 16C25.25 10.8914 21.1086 6.75 16 6.75ZM5.25 16C5.25 10.0629 10.0629 5.25 16 5.25C21.9371 5.25 26.75 10.0629 26.75 16C26.75 21.9371 21.9371 26.75 16 26.75C10.0629 26.75 5.25 21.9371 5.25 16ZM16.0303 12.4697C16.3232 12.7626 16.3232 13.2374 16.0303 13.5303L13.5607 16L16.0303 18.4697C16.3232 18.7626 16.3232 19.2374 16.0303 19.5303C15.7374 19.8232 15.2626 19.8232 14.9697 19.5303L11.9697 16.5303C11.6768 16.2374 11.6768 15.7626 11.9697 15.4697L14.9697 12.4697C15.2626 12.1768 15.7374 12.1768 16.0303 12.4697ZM20.0303 12.4697C20.3232 12.7626 20.3232 13.2374 20.0303 13.5303L17.5607 16L20.0303 18.4697C20.3232 18.7626 20.3232 19.2374 20.0303 19.5303C19.7374 19.8232 19.2626 19.8232 18.9697 19.5303L15.9697 16.5303C15.6768 16.2374 15.6768 15.7626 15.9697 15.4697L18.9697 12.4697C19.2626 12.1768 19.7374 12.1768 20.0303 12.4697Z",
    fill: "#1E6AFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextVv);
export default __webpack_public_path__ + "static/media/NextVV.da96cb8993fd0b3f781e9cf5d96d8d99.svg";
export { ForwardRef as ReactComponent };